import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class AmoPlaceTradeUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(req) {
        return await this.Repo.placeAmoTrade(req);
    }
}
export default AmoPlaceTradeUseCase;
